import React from 'react';
import { CreateForm } from 'framework/form';
import useFeatureToggle from 'framework/featureToggle';
import { Features } from 'infrastructure/featureToggle';
import { useVacancyGroupService, VACANCY_CREATE_FLOW } from 'domain/shared/newVacancy';
import { OneStopPageLayout } from 'domain/shared/oneStop';
import VacancyForm from '../VacancyForm';
import VacancyPositionSlotForm from '../VacancyPositionSlotForm';
import { useVacancyGroupUrl } from '../../routing';

const OneStopCreateVacancy = () => {
  const { newDashboard } = useVacancyGroupUrl();
  const { createVacancy, getCreateValidationSchema } = useVacancyGroupService();
  const { isFeatureEnabled } = useFeatureToggle();
  const positionSlotsEnabled = isFeatureEnabled(Features.HIRING_REQUEST_POSITION_SLOTS);

  return (
    <CreateForm
      submitFormFunc={createVacancy}
      afterSubmit={{
        redirect: newDashboard,
        message: 'You are awesome! The Vacancy has been successfully created.',
      }}
      getValidationSchemaFunc={getCreateValidationSchema}
      initialData={{
        vacancyCreateFlow: positionSlotsEnabled ? VACANCY_CREATE_FLOW.POSITION_SLOTS : VACANCY_CREATE_FLOW.STANDARD,
        workingConditions: [
          {
            hiringLocation: '',
            employmentTypes: [],
            contractTypes: [],
            isRelocationAvailable: '',
          },
        ],
      }}
    >
      <OneStopPageLayout>{positionSlotsEnabled ? <VacancyPositionSlotForm /> : <VacancyForm />}</OneStopPageLayout>
    </CreateForm>
  );
};

export default OneStopCreateVacancy;
